export interface RegisterInterestOpenOptions {
  projectId?: string;
  projectName?: string;
  phaseId?: string;
  designTypeId?: string;
}

type Opener = (options?: RegisterInterestOpenOptions) => void;

let opener: Opener | null = null;

export function registerOpener(fn: Opener): () => void {
  opener = fn;
  return () => {
    if (opener === fn) {
      opener = null;
    }
  };
}

export function openRegisterInterest(options?: RegisterInterestOpenOptions): void {
  opener?.(options);
}
